import { InstrumentOrderPreview, PlaceInstrument, UpvestOrderTransaction } from '../models';
import { ConfirmOrderRequest, InstrumentPreviewRequest,OrderInstrumentRequest,ConfirmInstrumentOperationRequest } from '../requests';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
export class InstrumentTradingService{
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    public static async getOrderPreview(request:InstrumentPreviewRequest):Promise<InstrumentOrderPreview>{
        const url = this.links.getIntrumentTradingPreview();
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        const json= await this.requester.post(url,this.headers,request);
        return json.data;
    }
    public static async sendOrderData(request:OrderInstrumentRequest):Promise<PlaceInstrument>{
        const url = this.links.getIntrumentOrderPlacement();
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        const json= await this.requester.post(url,this.headers,request);
        return json.data;
    }
    public static async confirmOrder(request:ConfirmInstrumentOperationRequest):Promise<UpvestOrderTransaction>{
        const url = this.links.confirmInstrumentOrder();
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        const json= await this.requester.post(url,this.headers,request);
        return json.data;
    }
}